/**
 * «Печатает…» и его родственники.
 *
 * Формулировки повторяют Telegram: в личном чате — без имени (и так ясно,
 * кто), в группе — с именем. Действие живёт недолго: Telegram шлёт его каждые
 * несколько секунд, пока оно длится, и без обновления считает истёкшим через
 * ~6 секунд. Клиент гасит по тому же таймеру — иначе «печатает» зависало бы
 * навсегда после обрыва.
 */

import type { TelegramChatAction, TelegramChatDto } from '@tw/shared-types';

/** Сколько держать действие без обновления. Как в официальных клиентах. */
export const CHAT_ACTION_TTL_MS = 6000;

const LABELS: Record<Exclude<TelegramChatAction, 'cancel'>, string> = {
  typing: 'печатает',
  recordingVoice: 'записывает голосовое',
  uploadingVoice: 'отправляет голосовое',
  recordingVideoNote: 'записывает видеосообщение',
  uploadingVideoNote: 'отправляет видеосообщение',
  uploadingPhoto: 'отправляет фото',
  uploadingVideo: 'отправляет видео',
  uploadingDocument: 'отправляет файл',
  choosingSticker: 'выбирает стикер',
  choosingLocation: 'выбирает геопозицию',
  choosingContact: 'выбирает контакт',
  playingGame: 'играет',
};

export interface ChatActivity {
  label: string;
  /** Момент, после которого действие считается истёкшим. */
  until: number;
}

/**
 * Подпись действия или null для `cancel` и незнакомого действия.
 *
 * Имя подставляется только в групповых чатах: в личном оно избыточно, а в
 * канале действий не бывает.
 */
export function chatActionLabel(
  action: TelegramChatAction,
  senderName: string | null,
  chatType: TelegramChatDto['type'] | string,
): string | null {
  if (action === 'cancel') return null;
  const verb = LABELS[action];
  if (!verb) return null;
  const group = chatType === 'group' || chatType === 'supergroup';
  return group && senderName ? `${senderName} ${verb}` : verb;
}
